export default "__VITE_ASSET__BdbVjQge__"